export const login = async (mail, password) => {

    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}/prod/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mail, password }),
    });
  
    console.log(response);    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error en la autenticación');
    }
  
    const data = await response.json();

    // La API puede devolver body como objeto directo o anidado
    const body = data.body || data;
    const id_vendedor = body.id_vendedor;
    const nombre = body.nombre;
    // idvendedor_crm: si viene con valor, el CRM/reportes muestran los datos de ese vendedor
    const idvendedor_crm = body.idvendedor_crm || '';
    // rol: 'admin' o 'vendedor'; controla la visibilidad de los paneles de administracion
    const rol = body.rol || '';

    if (!id_vendedor) {
      throw new Error('Credenciales incorrectas');
    }

    localStorage.setItem('id_vendedor', id_vendedor);
    localStorage.setItem('nombre', nombre || '');
    localStorage.setItem('idvendedor_crm', idvendedor_crm);
    localStorage.setItem('rol', rol);
    return { id_vendedor, nombre, idvendedor_crm, rol };
  };
  
  export const logout = () => {
    localStorage.removeItem('id_vendedor');
    localStorage.removeItem('nombre');
    localStorage.removeItem('idvendedor_crm');
    localStorage.removeItem('rol');
  };
  
  export const isAuthenticated = () => {
    const id = localStorage.getItem('id_vendedor');
    return id !== null && id !== '' && id !== 'undefined' && id !== 'null';
  };
  